// @ts-nocheck
import CustomerChangeModal from '@/components/modals/customer-change-modal';
import * as Enums from '@/utils/enums';

const QueryCustomerChangeModal = ({ open, onClose, currentItem, accessStatus, onCustomerChanged }: any) => (
    <CustomerChangeModal
        open={open}
        onClose={onClose}
        itemLabel={currentItem.QueryCode}
        moduleLabel="query"
        description="Changing the customer reassigns any related quotes and invoices still in draft. You cannot change the customer when there are related quotes or invoices that are approved or have linked payments."
        cannotChangePrefix="This query has quotes or invoices that are already accepted, invoiced, approved or paid."
        checkUrl={`/Query/QueryCustomerChangeCheck?queryID=${currentItem.ID}`}
        changeUrl="/Query/QueryCustomerChange"
        itemIdKey="QueryID"
        itemId={currentItem.ID}
        moduleType={Enums.Module.Query}
        excludedCustomerID={currentItem.CustomerID}
        accessStatus={accessStatus}
        onCustomerChanged={onCustomerChanged}
    />
);

export default QueryCustomerChangeModal;
